import {PageContent} from "./PageContent";

export const Mitmachen = () => {
    return (
        <PageContent
            slug="mitmachen"
            fallbackTitle="Mitmachen"
        >
            <p></p>
        </PageContent>
)}
